import { NUMERICAL_GRADE_BANDS } from "@/constants/GradeAndLexileLevels";
import getLanguageCode from "@/view/utils/getLanguageCode";

const findLevelLockedContent = (matchedAssignment, levels = [], contentId) => {
  const matchedAssignmentMember = matchedAssignment?.assignment_members?.find(
    (member) => {
      return member?.content?.story_content_id === contentId;
    },
  );

  const assignmentLanguage = matchedAssignmentMember?.content?.language;

  const levelsFilteredByLanguage = levels.filter((level) => {
    const levelLanguage = getLanguageCode(level.language);
    return levelLanguage === assignmentLanguage;
  });

  const gradeLevelLock = matchedAssignment?.grade_level_lock;

  const level = levelsFilteredByLanguage?.find((level) => {
    return NUMERICAL_GRADE_BANDS[level.grade_band] === gradeLevelLock;
  });

  let fallbackLevel;

  if (!level) {
    const allLevelNumericGradeBands = levelsFilteredByLanguage.map((level) => {
      return parseInt(level.grade_band.split("_")[1]);
    });

    // Remove all levels greater than the grade lock level.
    // We know that the grade lock level doesn't exist, so this should mean the last index of this array is the level we want.
    const allPossibleLevelsBelowLockedLevel = allLevelNumericGradeBands.filter(
      (gradeBand) => gradeBand < gradeLevelLock,
    );

    const newLevelIndex =
      allPossibleLevelsBelowLockedLevel[
        allPossibleLevelsBelowLockedLevel.length - 1
      ];
    const firstFallBackLevel = levelsFilteredByLanguage.find(
      (level) => level.grade_band === `GRADE_${newLevelIndex}`,
    );
    fallbackLevel = firstFallBackLevel || levels[0];
  }

  return level || fallbackLevel;
};

export default findLevelLockedContent;
